<template>
	<div class="login_page">
		<div class="login-pan">
			<p class="title">「后台管理系统」</p>
			<el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0" class="login-form">
				<el-form-item prop="email">
					<el-input type="text" v-model="loginForm.email" name="email" placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')" name="password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-button type="button" @click.native.prevent="submitForm('loginForm')" class="btn">登 录</el-button>
			</el-form>
		</div>
	</div>
</template>

<script>
	import { setLocalStorage, setUserName } from '../../utils/localStorage.js';
	export default {
		data() {
			return {
				loginForm: {
					email: '',
					password: '',
				},
				rules: {
					email: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					]
				},
			}
		},
		methods: {
			submitForm() {
				this.$http.post('/user/login', this.loginForm).then(res => {
					if (res.data.code == 0) {
						setLocalStorage(res.data.data.token);
						setUserName(res.data.data.username);
						this.$router.push({ path: '/home'});
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="less">
	.login_page{
		width: 100%;
		height: 100%;
		background: url('../../assets/bg2.png') no-repeat;
		background-position: center;
		background-size: cover;
		.login-pan{
			width: 390px;
			height: 300px;
			padding: 90px;
			border-radius: 10px;
			background: #fff;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			.title{
				text-align: center;
				font-size: 30px;
				color: #1c93fb;
				margin-bottom: 20px;
			}
			.login-form{
				width: 327px;
				margin: 0 30px;
			}
			.btn{
				width: 327px;
				height: 57px;
				background: url("../../assets/btn.png") no-repeat;
				color: #fff;
				font-size: 18px;
				margin-top: 15px;
			}
			.el-button{
				border: none;
			}
			.el-form-item{
				margin-bottom: 35px;
			}
		}
	}
</style>
